import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from "@angular/core";
import { EdButtonComponent } from "@edenred/components/button";
import { TranslocoPipe } from "@jsverse/transloco";
import { MatIconModule } from "@angular/material/icon";
import { CommonModule, NgTemplateOutlet } from "@angular/common";
import {
  BaseConfirmPromptSizeEnum,
  BaseConfirmPromptTypeEnum,
} from "./enums/base-confirm-prompt-size.enum";

const i18ConfirmPrompt = "confirm_prompt";

@Component({
  selector: "er-base-confirm-prompt",
  templateUrl: "./base-confirm-prompt.component.html",
  styleUrls: ["./base-confirm-prompt.component.scss"],
  imports: [
    EdButtonComponent,
    TranslocoPipe,
    MatIconModule,
    NgTemplateOutlet,
    CommonModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class BaseConfirmPromptComponent {
  @Input()
  public title?: string;
  @Input()
  public content!: TemplateRef<void>;
  @Input()
  public disableConfirmButton = false;
  @Input()
  public hideIcon = false;
  @Input()
  public size: BaseConfirmPromptSizeEnum = BaseConfirmPromptSizeEnum.SM;
  @Input()
  public type: BaseConfirmPromptTypeEnum = BaseConfirmPromptTypeEnum.DEFAULT;
  @Input()
  public cancelBtnLabel = `${i18ConfirmPrompt}.close`;
  @Input()
  public confirmBtnLabel = `${i18ConfirmPrompt}.confirm`;
  @Input()
  public icon: string | null = null;

  @Output()
  public confirm: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public close: EventEmitter<any> = new EventEmitter<any>();

  protected readonly BaseConfirmPromptSize: typeof BaseConfirmPromptSizeEnum =
    BaseConfirmPromptSizeEnum;
  protected readonly BaseConfirmPromptType: typeof BaseConfirmPromptTypeEnum =
    BaseConfirmPromptTypeEnum;

  public onConfirmClick(event?: any): void {
    this.confirm.emit(event);
  }

  public onCloseClick(event?: any): void {
    this.close.emit(event);
  }
}
